import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

const CookieNotice = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("lumiere-consent")) {
      const t = setTimeout(() => setVisible(true), 2500);
      return () => clearTimeout(t);
    }
  }, []);

  const choose = (value) => {
    localStorage.setItem("lumiere-consent", value);
    window.dispatchEvent(new Event("lumiere-consent-change"));
    setVisible(false);
    if (value !== "accepted" && (window.fbq || window.gtag)) window.location.reload();
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 60, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 60, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-0 inset-x-0 z-50 bg-cream border-t border-hairline/60"
          data-testid="cookie-notice"
          role="dialog"
          aria-label="Cookie notice"
        >
          <div className="shell py-4 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-ink/80 text-sm" data-testid="cookie-notice-text">
              We use cookies to understand how the site is used and to measure our advertising. Non-essential scripts run only with your consent.{" "}
              <Link to="/privacy" className="underline underline-offset-2 hover:text-gold transition-colors" data-testid="cookie-notice-privacy-link">Privacy Policy</Link>
            </p>
            <div className="flex gap-3 shrink-0">
              <button
                onClick={() => choose("accepted")}
                data-testid="cookie-accept-button"
                className="btn-gold px-5 py-2.5 text-sm font-medium"
              >
                Accept
              </button>
              <button
                onClick={() => choose("essential-only")}
                data-testid="cookie-manage-button"
                className="px-5 py-2.5 text-sm text-deep-sea border border-deep-sea rounded-lg hover:bg-deep-sea hover:text-cream transition-colors duration-300"
              >
                Essential only
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieNotice;
